import { Table } from "antd";

const TableContent = ({
  className = "",
  rowSelection = undefined,
  rowClassName = "",
  bordered = false,
  columns = [],
  dataSource = [],
  components = undefined,
  loading = false,
  pagination = false,
  onChange = undefined,
}) => {
  return (
    <Table
      className={className}
      rowKey={(record) => record._id || record.id}
      rowSelection={rowSelection}
      rowClassName={rowClassName}
      bordered={bordered}
      columns={columns}
      dataSource={dataSource}
      components={components}
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      scroll={{ x: "max-content" }}
    />
  );
};

export default TableContent;
